import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { getIucnRedListSpeciesUrl } from 'utils/iucnRedListUrl'

import {
  ScientificNameFieldContainer,
  ScientificNameLabel,
  ScientificNameLink,
  ScientificNameText,
  ScientificNameValue
} from '../style'

const openIucnAssessment = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

const ScientificNameField = ({ scientificName, taxonid, assessmentId, isGrayedOut = false }) => {
  const iucnUrl = getIucnRedListSpeciesUrl(taxonid, assessmentId)
  const hasLink = Boolean(iucnUrl)
  const isValueGrayedOut = isGrayedOut || !hasLink

  const handleNameLinkClick = () => {
    openIucnAssessment(iucnUrl)
  }

  const handleNameLinkKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      openIucnAssessment(iucnUrl)
    }
  }

  return (
    <ScientificNameFieldContainer>
      <ScientificNameLabel id="scientific-name-label">
        <FormattedMessage id="scientificName" />
      </ScientificNameLabel>
      <ScientificNameValue
        data-testid="scientific-name-value"
        aria-labelledby="scientific-name-label"
        data-selectable="true"
        data-grayed-out={isValueGrayedOut ? 'true' : 'false'}
        data-has-link={hasLink ? 'true' : 'false'}
      >
        {hasLink ? (
          <ScientificNameLink
            role="link"
            tabIndex={0}
            onClick={handleNameLinkClick}
            onKeyDown={handleNameLinkKeyDown}
            aria-label={`${scientificName} (IUCN Red List)`}
            data-testid="scientific-name-link"
          >
            {scientificName}
          </ScientificNameLink>
        ) : (
          <ScientificNameText>{scientificName}</ScientificNameText>
        )}
      </ScientificNameValue>
    </ScientificNameFieldContainer>
  )
}

export default ScientificNameField

ScientificNameField.propTypes = {
  scientificName: PropTypes.string.isRequired,
  taxonid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  assessmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isGrayedOut: PropTypes.bool
}
